import React from "react";
import { defineMessages, FormattedMessage } from "react-intl";

import { TextCenter } from "src/common/components/TextAlign";

import "./AuthPage.css";

const messages = defineMessages({
	privacyPolicy: {
		id: "auth.privacy_policy",
		defaultMessage: "Adatkezelési betegtájékoztató"
	},
	neumannMedicalPrivacyPolicy: {
		id: "auth.neumann_medical_privacy_policy",
		defaultMessage: "Adatkezelési tájékoztató"
	}
});

interface AuthPageProps {
	logo?: React.ReactNode;
}

export const AuthPage: React.FunctionComponent<
	React.PropsWithChildren<AuthPageProps>
> = ({ logo, children }) => (
	<div className="auth-page">
		<div className="auth-page__pane auth-page__pane--left"></div>
		<div className="auth-page__pane auth-page__pane--right">
			<div className="auth-page__body">
				{logo && <div className="auth-page__logo">{logo}</div>}
				{children}
			</div>
			<div className="auth-page__footer">
				<TextCenter>
					<a
						href="/TIMM_Adatkezelesi_Tajekoztato.pdf"
						target="_blank"
						rel="noopener"
					>
						<FormattedMessage
							{...messages.neumannMedicalPrivacyPolicy}
						/>
					</a>
				</TextCenter>
			</div>
		</div>
	</div>
);
